import React, { useState, useEffect } from 'react';
import {
  Button, Modal, Row, Col,
} from 'react-bootstrap';
import { LoadingAnimation } from '../../common/components/Utilities';
import ObjectiveResource from '../../common/resource/ObjectiveResource';
import LegacyUserResource from '../../common/resource/LegacyUserResource';

function ArchivedObjectives({ activeUser, groups }) {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [hasPermission, setHasPermission] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [objectives, setObjectives] = useState([]);

  const loadObjectives = async () => {
    setLoading(true);

    try {
      const response = await ObjectiveResource.getTrashed(user.id);
      setObjectives(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const loadUser = async () => {
    let loadedUser = {};
    setLoading(true);
    const pageUrlUserId = window.location.pathname.split('/')[2];

    try {
      loadedUser = await LegacyUserResource.get(pageUrlUserId);
      setHasPermission(
        (loadedUser.manager.id === activeUser.id) || activeUser.isInGroup(groups.TEAM_LEADS),
      );
    } catch (exception) {
      console.log(exception);
    } finally {
      setLoading(false);
    }
    return loadedUser;
  };

  useEffect(() => {
    let isMounted = true;
    loadUser().then((loadedUserThen) => {
      if (isMounted) setUser(loadedUserThen);
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const handleShow = () => {
    loadObjectives();
  };

  const handleRestore = async (id) => {
    setLoading(true);
    let response;

    try {
      response = await ObjectiveResource.restore(id);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }

    if (response) {
      loadObjectives();
    }
  };

  const handleClose = () => {
    setLoading(true);
    const newLocation = window.location;
    window.location = newLocation;
  };

  if (!hasPermission) {
    return null;
  }

  return (
    <>
      <Button type="button" onClick={() => setShowModal(!showModal)} className="btn btn-primary" id="view-archived-objectives">
        <i className="fa fa-trash" />
        {' '}
        View Archived
      </Button>

      <Modal show={showModal} onShow={handleShow} onHide={handleClose} size="lg">
        <LoadingAnimation loading={loading} />
        <Modal.Header closeButton>
          <Modal.Title>Archived Objectives</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {(!objectives.length && !loading)

            && <p>None found.</p>}

          {objectives.map((objective, key) => (

            <Row key={key} className="mb-4 border-bottom pb-3">
              <Col md={9}>
                {objective.description}
              </Col>
              <Col md={3}>
                <Button className="" type="button" variant="primary" onClick={() => { handleRestore(objective.id); }}>Restore</Button>
              </Col>
            </Row>

          ))}

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default ArchivedObjectives;
